export const colors = [
	{
		color: 'rgba(255, 235, 238, 1)',
		label: 'Red 50'
	},
	{
		color: 'rgba(255, 205, 210, 1)',
		label: 'Red 100'
	},
	{
		color: 'rgba(239, 154, 154, 1)',
		label: 'Red 200'
	},
	{
		color: 'rgba(229, 115, 115, 1)',
		label: 'Red 300'
	},
	{
		color: 'rgba(239, 83, 80, 1)',
		label: 'Red 400'
	},
	{
		color: 'rgba(244, 67, 54, 1)',
		label: 'Red 500'
	},
	{
		color: 'rgba(229, 57, 53, 1)',
		label: 'Red 600'
	},
	{
		color: 'rgba(211, 47, 47, 1)',
		label: 'Red 700'
	},
	{
		color: 'rgba(198, 40, 40, 1)',
		label: 'Red 800'
	},
	{
		color: 'rgba(183, 28, 28, 1)',
		label: 'Red 900'
	},
	{
		color: 'rgba(255, 138, 128, 1)',
		label: 'Red A100'
	},
	{
		color: 'rgba(255, 82, 82, 1)',
		label: 'Red A200'
	},
	{
		color: 'rgba(255, 23, 68, 1)',
		label: 'Red A400'
	},
	{
		color: 'rgba(213, 0, 0, 1)',
		label: 'Red A700'
	},
	{
		color: 'rgba(252, 228, 236, 1)',
		label: 'Pink 50'
	},
	{
		color: 'rgba(248, 187, 208, 1)',
		label: 'Pink 100'
	},
	{
		color: 'rgba(244, 143, 177, 1)',
		label: 'Pink 200'
	},
	{
		color: 'rgba(240, 98, 146, 1)',
		label: 'Pink 300'
	},
	{
		color: 'rgba(236, 64, 122, 1)',
		label: 'Pink 400'
	},
	{
		color: 'rgba(233, 30, 99, 1)',
		label: 'Pink 500'
	},
	{
		color: 'rgba(216, 27, 96, 1)',
		label: 'Pink 600'
	},
	{
		color: 'rgba(194, 24, 91, 1)',
		label: 'Pink 700'
	},
	{
		color: 'rgba(173, 20, 87, 1)',
		label: 'Pink 800'
	},
	{
		color: 'rgba(136, 14, 79, 1)',
		label: 'Pink 900'
	},
	{
		color: 'rgba(255, 128, 171, 1)',
		label: 'Pink A100'
	},
	{
		color: 'rgba(255, 64, 129, 1)',
		label: 'Pink A200'
	},
	{
		color: 'rgba(245, 0, 87, 1)',
		label: 'Pink A400'
	},
	{
		color: 'rgba(197, 17, 98, 1)',
		label: 'Pink A700'
	},
	{
		color: 'rgba(243, 229, 245, 1)',
		label: 'Purple 50'
	},
	{
		color: 'rgba(225, 190, 231, 1)',
		label: 'Purple 100'
	},
	{
		color: 'rgba(206, 147, 216, 1)',
		label: 'Purple 200'
	},
	{
		color: 'rgba(186, 104, 200, 1)',
		label: 'Purple 300'
	},
	{
		color: 'rgba(171, 71, 188, 1)',
		label: 'Purple 400'
	},
	{
		color: 'rgba(156, 39, 176, 1)',
		label: 'Purple 500'
	},
	{
		color: 'rgba(142, 36, 170, 1)',
		label: 'Purple 600'
	},
	{
		color: 'rgba(123, 31, 162, 1)',
		label: 'Purple 700'
	},
	{
		color: 'rgba(106, 27, 154, 1)',
		label: 'Purple 800'
	},
	{
		color: 'rgba(74, 20, 140, 1)',
		label: 'Purple 900'
	},
	{
		color: 'rgba(234, 128, 252, 1)',
		label: 'Purple A100'
	},
	{
		color: 'rgba(224, 64, 251, 1)',
		label: 'Purple A200'
	},
	{
		color: 'rgba(213, 0, 249, 1)',
		label: 'Purple A400'
	},
	{
		color: 'rgba(170, 0, 255, 1)',
		label: 'Purple A700'
	},
	{
		color: 'rgba(237, 231, 246, 1)',
		label: 'Deep Purple 50'
	},
	{
		color: 'rgba(209, 196, 233, 1)',
		label: 'Deep Purple 100'
	},
	{
		color: 'rgba(179, 157, 219, 1)',
		label: 'Deep Purple 200'
	},
	{
		color: 'rgba(149, 117, 205, 1)',
		label: 'Deep Purple 300'
	},
	{
		color: 'rgba(126, 87, 194, 1)',
		label: 'Deep Purple 400'
	},
	{
		color: 'rgba(103, 58, 183, 1)',
		label: 'Deep Purple 500'
	},
	{
		color: 'rgba(94, 53, 177, 1)',
		label: 'Deep Purple 600'
	},
	{
		color: 'rgba(81, 45, 168, 1)',
		label: 'Deep Purple 700'
	},
	{
		color: 'rgba(69, 39, 160, 1)',
		label: 'Deep Purple 800'
	},
	{
		color: 'rgba(49, 27, 146, 1)',
		label: 'Deep Purple 900'
	},
	{
		color: 'rgba(179, 136, 255, 1)',
		label: 'Deep Purple A100'
	},
	{
		color: 'rgba(124, 77, 255, 1)',
		label: 'Deep Purple A200'
	},
	{
		color: 'rgba(101, 31, 255, 1)',
		label: 'Deep Purple A400'
	},
	{
		color: 'rgba(98, 0, 234, 1)',
		label: 'Deep Purple A700'
	},
	{
		color: 'rgba(232, 234, 246, 1)',
		label: 'Indigo 50'
	},
	{
		color: 'rgba(197, 202, 233, 1)',
		label: 'Indigo 100'
	},
	{
		color: 'rgba(159, 168, 218, 1)',
		label: 'Indigo 200'
	},
	{
		color: 'rgba(121, 134, 203, 1)',
		label: 'Indigo 300'
	},
	{
		color: 'rgba(92, 107, 192, 1)',
		label: 'Indigo 400'
	},
	{
		color: 'rgba(63, 81, 181, 1)',
		label: 'Indigo 500'
	},
	{
		color: 'rgba(57, 73, 171, 1)',
		label: 'Indigo 600'
	},
	{
		color: 'rgba(48, 63, 159, 1)',
		label: 'Indigo 700'
	},
	{
		color: 'rgba(40, 53, 147, 1)',
		label: 'Indigo 800'
	},
	{
		color: 'rgba(26, 35, 126, 1)',
		label: 'Indigo 900'
	},
	{
		color: 'rgba(140, 158, 255, 1)',
		label: 'Indigo A100'
	},
	{
		color: 'rgba(83, 109, 254, 1)',
		label: 'Indigo A200'
	},
	{
		color: 'rgba(61, 90, 254, 1)',
		label: 'Indigo A400'
	},
	{
		color: 'rgba(48, 79, 254, 1)',
		label: 'Indigo A700'
	},
	{
		color: 'rgba(227, 242, 253, 1)',
		label: 'Blue 50'
	},
	{
		color: 'rgba(187, 222, 251, 1)',
		label: 'Blue 100'
	},
	{
		color: 'rgba(144, 202, 249, 1)',
		label: 'Blue 200'
	},
	{
		color: 'rgba(100, 181, 246, 1)',
		label: 'Blue 300'
	},
	{
		color: 'rgba(66, 165, 245, 1)',
		label: 'Blue 400'
	},
	{
		color: 'rgba(33, 150, 243, 1)',
		label: 'Blue 500'
	},
	{
		color: 'rgba(30, 136, 229, 1)',
		label: 'Blue 600'
	},
	{
		color: 'rgba(25, 118, 210, 1)',
		label: 'Blue 700'
	},
	{
		color: 'rgba(21, 101, 192, 1)',
		label: 'Blue 800'
	},
	{
		color: 'rgba(13, 71, 161, 1)',
		label: 'Blue 900'
	},
	{
		color: 'rgba(130, 177, 255, 1)',
		label: 'Blue A100'
	},
	{
		color: 'rgba(68, 138, 255, 1)',
		label: 'Blue A200'
	},
	{
		color: 'rgba(41, 121, 255, 1)',
		label: 'Blue A400'
	},
	{
		color: 'rgba(41, 98, 255, 1)',
		label: 'Blue A700'
	},
	{
		color: 'rgb(0, 0, 128)',
		label: 'Dark Blue'
	},
	{
		color: 'rgba(225, 245, 254, 1)',
		label: 'Light Blue 50'
	},
	{
		color: 'rgba(179, 229, 252, 1)',
		label: 'Light Blue 100'
	},
	{
		color: 'rgba(129, 212, 250, 1)',
		label: 'Light Blue 200'
	},
	{
		color: 'rgba(79, 195, 247, 1)',
		label: 'Light Blue 300'
	},
	{
		color: 'rgba(41, 182, 246, 1)',
		label: 'Light Blue 400'
	},
	{
		color: 'rgba(3, 169, 244, 1)',
		label: 'Light Blue 500'
	},
	{
		color: 'rgba(3, 155, 229, 1)',
		label: 'Light Blue 600'
	},
	{
		color: 'rgba(2, 136, 209, 1)',
		label: 'Light Blue 700'
	},
	{
		color: 'rgba(2, 119, 189, 1)',
		label: 'Light Blue 800'
	},
	{
		color: 'rgba(1, 87, 155, 1)',
		label: 'Light Blue 900'
	},
	{
		color: 'rgba(128, 216, 255, 1)',
		label: 'Light Blue A100'
	},
	{
		color: 'rgba(64, 196, 255, 1)',
		label: 'Light Blue A200'
	},
	{
		color: 'rgba(0, 176, 255, 1)',
		label: 'Light Blue A400'
	},
	{
		color: 'rgba(0, 145, 234, 1)',
		label: 'Light Blue A700'
	},
	{
		color: 'rgb(0, 32, 96)',
		label: 'Light Blue'
	},
	{
		color: 'rgba(224, 247, 250, 1)',
		label: 'Cyan 50'
	},
	{
		color: 'rgba(178, 235, 242, 1)',
		label: 'Cyan 100'
	},
	{
		color: 'rgba(128, 222, 234, 1)',
		label: 'Cyan 200'
	},
	{
		color: 'rgba(77, 208, 225, 1)',
		label: 'Cyan 300'
	},
	{
		color: 'rgba(38, 198, 218, 1)',
		label: 'Cyan 400'
	},
	{
		color: 'rgba(0, 188, 212, 1)',
		label: 'Cyan 500'
	},
	{
		color: 'rgba(0, 172, 193, 1)',
		label: 'Cyan 600'
	},
	{
		color: 'rgba(0, 151, 167, 1)',
		label: 'Cyan 700'
	},
	{
		color: 'rgba(0, 131, 143, 1)',
		label: 'Cyan 800'
	},
	{
		color: 'rgba(0, 96, 100, 1)',
		label: 'Cyan 900'
	},
	{
		color: 'rgba(132, 255, 255, 1)',
		label: 'Cyan A100'
	},
	{
		color: 'rgba(24, 255, 255, 1)',
		label: 'Cyan A200'
	},
	{
		color: 'rgba(0, 229, 255, 1)',
		label: 'Cyan A400'
	},
	{
		color: 'rgba(0, 184, 212, 1)',
		label: 'Cyan A700'
	},
	{
		color: 'rgba(224, 242, 241, 1)',
		label: 'Teal 50'
	},
	{
		color: 'rgba(178, 223, 219, 1)',
		label: 'Teal 100'
	},
	{
		color: 'rgba(128, 203, 196, 1)',
		label: 'Teal 200'
	},
	{
		color: 'rgba(77, 182, 172, 1)',
		label: 'Teal 300'
	},
	{
		color: 'rgba(38, 166, 154, 1)',
		label: 'Teal 400'
	},
	{
		color: 'rgba(0, 150, 136, 1)',
		label: 'Teal 500'
	},
	{
		color: 'rgba(0, 137, 123, 1)',
		label: 'Teal 600'
	},
	{
		color: 'rgba(0, 121, 107, 1)',
		label: 'Teal 700'
	},
	{
		color: 'rgba(0, 105, 92, 1)',
		label: 'Teal 800'
	},
	{
		color: 'rgba(0, 77, 64, 1)',
		label: 'Teal 900'
	},
	{
		color: 'rgba(167, 255, 235, 1)',
		label: 'Teal A100'
	},
	{
		color: 'rgba(100, 255, 218, 1)',
		label: 'Teal A200'
	},
	{
		color: 'rgba(29, 233, 182, 1)',
		label: 'Teal A400'
	},
	{
		color: 'rgba(0, 191, 165, 1)',
		label: 'Teal A700'
	},
	{
		color: 'rgba(232, 245, 233, 1)',
		label: 'Green 50'
	},
	{
		color: 'rgba(200, 230, 201, 1)',
		label: 'Green 100'
	},
	{
		color: 'rgba(165, 214, 167, 1)',
		label: 'Green 200'
	},
	{
		color: 'rgba(129, 199, 132, 1)',
		label: 'Green 300'
	},
	{
		color: 'rgba(102, 187, 106, 1)',
		label: 'Green 400'
	},
	{
		color: 'rgba(76, 175, 80, 1)',
		label: 'Green 500'
	},
	{
		color: 'rgba(67, 160, 71, 1)',
		label: 'Green 600'
	},
	{
		color: 'rgba(56, 142, 60, 1)',
		label: 'Green 700'
	},
	{
		color: 'rgba(46, 125, 50, 1)',
		label: 'Green 800'
	},
	{
		color: 'rgba(27, 94, 32, 1)',
		label: 'Green 900'
	},
	{
		color: 'rgba(185, 246, 202, 1)',
		label: 'Green A100'
	},
	{
		color: 'rgba(105, 240, 174, 1)',
		label: 'Green A200'
	},
	{
		color: 'rgba(0, 230, 118, 1)',
		label: 'Green A400'
	},
	{
		color: 'rgba(0, 200, 83, 1)',
		label: 'Green A700'
	},
	{
		color: 'rgba(241, 248, 233, 1)',
		label: 'Light Green 50'
	},
	{
		color: 'rgba(220, 237, 200, 1)',
		label: 'Light Green 100'
	},
	{
		color: 'rgba(197, 225, 165, 1)',
		label: 'Light Green 200'
	},
	{
		color: 'rgba(174, 213, 129, 1)',
		label: 'Light Green 300'
	},
	{
		color: 'rgba(156, 204, 101, 1)',
		label: 'Light Green 400'
	},
	{
		color: 'rgba(139, 195, 74, 1)',
		label: 'Light Green 500'
	},
	{
		color: 'rgba(124, 179, 66, 1)',
		label: 'Light Green 600'
	},
	{
		color: 'rgba(104, 159, 56, 1)',
		label: 'Light Green 700'
	},
	{
		color: 'rgba(85, 139, 47, 1)',
		label: 'Light Green 800'
	},
	{
		color: 'rgba(51, 105, 30, 1)',
		label: 'Light Green 900'
	},
	{
		color: 'rgba(204, 255, 144, 1)',
		label: 'Light Green A100'
	},
	{
		color: 'rgba(178, 255, 89, 1)',
		label: 'Light Green A200'
	},
	{
		color: 'rgba(118, 255, 3, 1)',
		label: 'Light Green A400'
	},
	{
		color: 'rgba(100, 221, 23, 1)',
		label: 'Light Green A700'
	},
	{
		color: 'rgba(249, 251, 231, 1)',
		label: 'Lime 50'
	},
	{
		color: 'rgba(240, 244, 195, 1)',
		label: 'Lime 100'
	},
	{
		color: 'rgba(230, 238, 156, 1)',
		label: 'Lime 200'
	},
	{
		color: 'rgba(220, 231, 117, 1)',
		label: 'Lime 300'
	},
	{
		color: 'rgba(212, 225, 87, 1)',
		label: 'Lime 400'
	},
	{
		color: 'rgba(205, 220, 57, 1)',
		label: 'Lime 500'
	},
	{
		color: 'rgba(192, 202, 51, 1)',
		label: 'Lime 600'
	},
	{
		color: 'rgba(175, 180, 43, 1)',
		label: 'Lime 700'
	},
	{
		color: 'rgba(158, 157, 36, 1)',
		label: 'Lime 800'
	},
	{
		color: 'rgba(130, 119, 23, 1)',
		label: 'Lime 900'
	},
	{
		color: 'rgba(244, 255, 129, 1)',
		label: 'Lime A100'
	},
	{
		color: 'rgba(238, 255, 65, 1)',
		label: 'Lime A200'
	},
	{
		color: 'rgba(198, 255, 0, 1)',
		label: 'Lime A400'
	},
	{
		color: 'rgba(174, 234, 0, 1)',
		label: 'Lime A700'
	},
	{
		color: 'rgba(255, 253, 231, 1)',
		label: 'Yellow 50'
	},
	{
		color: 'rgba(255, 249, 196, 1)',
		label: 'Yellow 100'
	},
	{
		color: 'rgba(255, 245, 157, 1)',
		label: 'Yellow 200'
	},
	{
		color: 'rgba(255, 241, 118, 1)',
		label: 'Yellow 300'
	},
	{
		color: 'rgba(255, 238, 88, 1)',
		label: 'Yellow 400'
	},
	{
		color: 'rgba(255, 235, 59, 1)',
		label: 'Yellow 500'
	},
	{
		color: 'rgba(253, 216, 53, 1)',
		label: 'Yellow 600'
	},
	{
		color: 'rgba(251, 192, 45, 1)',
		label: 'Yellow 700'
	},
	{
		color: 'rgba(249, 168, 37, 1)',
		label: 'Yellow 800'
	},
	{
		color: 'rgba(245, 127, 23, 1)',
		label: 'Yellow 900'
	},
	{
		color: 'rgba(255, 255, 141, 1)',
		label: 'Yellow A100'
	},
	{
		color: 'rgba(255, 255, 0, 1)',
		label: 'Yellow A200'
	},
	{
		color: 'rgba(255, 234, 0, 1)',
		label: 'Yellow A400'
	},
	{
		color: 'rgba(255, 214, 0, 1)',
		label: 'Yellow A700'
	},
	{
		color: 'rgb(255, 204, 0)',
		label: 'Yellow'
	},
	{
		color: 'rgba(255, 248, 225, 1)',
		label: 'Amber 50'
	},
	{
		color: 'rgba(255, 236, 179, 1)',
		label: 'Amber 100'
	},
	{
		color: 'rgba(255, 224, 130, 1)',
		label: 'Amber 200'
	},
	{
		color: 'rgba(255, 213, 79, 1)',
		label: 'Amber 300'
	},
	{
		color: 'rgba(255, 202, 40, 1)',
		label: 'Amber 400'
	},
	{
		color: 'rgba(255, 193, 7, 1)',
		label: 'Amber 500'
	},
	{
		color: 'rgba(255, 179, 0, 1)',
		label: 'Amber 600'
	},
	{
		color: 'rgba(255, 160, 0, 1)',
		label: 'Amber 700'
	},
	{
		color: 'rgba(255, 143, 0, 1)',
		label: 'Amber 800'
	},
	{
		color: 'rgba(255, 111, 0, 1)',
		label: 'Amber 900'
	},
	{
		color: 'rgba(255, 229, 127, 1)',
		label: 'Amber A100'
	},
	{
		color: 'rgba(255, 215, 64, 1)',
		label: 'Amber A200'
	},
	{
		color: 'rgba(255, 196, 0, 1)',
		label: 'Amber A400'
	},
	{
		color: 'rgba(255, 171, 0, 1)',
		label: 'Amber A700'
	},
	{
		color: 'rgba(255, 243, 224, 1)',
		label: 'Orange 50'
	},
	{
		color: 'rgba(255, 224, 178, 1)',
		label: 'Orange 100'
	},
	{
		color: 'rgba(255, 204, 128, 1)',
		label: 'Orange 200'
	},
	{
		color: 'rgba(255, 183, 77, 1)',
		label: 'Orange 300'
	},
	{
		color: 'rgba(255, 167, 38, 1)',
		label: 'Orange 400'
	},
	{
		color: 'rgba(255, 152, 0, 1)',
		label: 'Orange 500'
	},
	{
		color: 'rgba(251, 140, 0, 1)',
		label: 'Orange 600'
	},
	{
		color: 'rgba(245, 124, 0, 1)',
		label: 'Orange 700'
	},
	{
		color: 'rgba(239, 108, 0, 1)',
		label: 'Orange 800'
	},
	{
		color: 'rgba(230, 81, 0, 1)',
		label: 'Orange 900'
	},
	{
		color: 'rgba(255, 209, 128, 1)',
		label: 'Orange A100'
	},
	{
		color: 'rgba(255, 171, 64, 1)',
		label: 'Orange A200'
	},
	{
		color: 'rgba(255, 145, 0, 1)',
		label: 'Orange A400'
	},
	{
		color: 'rgba(255, 109, 0, 1)',
		label: 'Orange A700'
	},
	{
		color: 'rgba(251, 233, 231, 1)',
		label: 'Deep Orange 50'
	},
	{
		color: 'rgba(255, 204, 188, 1)',
		label: 'Deep Orange 100'
	},
	{
		color: 'rgba(255, 171, 145, 1)',
		label: 'Deep Orange 200'
	},
	{
		color: 'rgba(255, 138, 101, 1)',
		label: 'Deep Orange 300'
	},
	{
		color: 'rgba(255, 112, 67, 1)',
		label: 'Deep Orange 400'
	},
	{
		color: 'rgba(255, 87, 34, 1)',
		label: 'Deep Orange 500'
	},
	{
		color: 'rgba(244, 81, 30, 1)',
		label: 'Deep Orange 600'
	},
	{
		color: 'rgba(230, 74, 25, 1)',
		label: 'Deep Orange 700'
	},
	{
		color: 'rgba(216, 67, 21, 1)',
		label: 'Deep Orange 800'
	},
	{
		color: 'rgba(191, 54, 12, 1)',
		label: 'Deep Orange 900'
	},
	{
		color: 'rgba(255, 158, 128, 1)',
		label: 'Deep Orange A100'
	},
	{
		color: 'rgba(255, 110, 64, 1)',
		label: 'Deep Orange A200'
	},
	{
		color: 'rgba(255, 61, 0, 1)',
		label: 'Deep Orange A400'
	},
	{
		color: 'rgba(221, 44, 0, 1)',
		label: 'Deep Orange A700'
	},
	{
		color: 'rgba(239, 235, 233, 1)',
		label: 'Brown 50'
	},
	{
		color: 'rgba(215, 204, 200, 1)',
		label: 'Brown 100'
	},
	{
		color: 'rgba(188, 170, 164, 1)',
		label: 'Brown 200'
	},
	{
		color: 'rgba(161, 136, 127, 1)',
		label: 'Brown 300'
	},
	{
		color: 'rgba(141, 110, 99, 1)',
		label: 'Brown 400'
	},
	{
		color: 'rgba(121, 85, 72, 1)',
		label: 'Brown 500'
	},
	{
		color: 'rgba(109, 76, 65, 1)',
		label: 'Brown 600'
	},
	{
		color: 'rgba(93, 64, 55, 1)',
		label: 'Brown 700'
	},
	{
		color: 'rgba(78, 52, 46, 1)',
		label: 'Brown 800'
	},
	{
		color: 'rgba(62, 39, 35, 1)',
		label: 'Brown 900'
	},
	{
		color: 'rgba(250, 250, 250, 1)',
		label: 'Grey 50'
	},
	{
		color: 'rgba(245, 245, 245, 1)',
		label: 'Grey 100'
	},
	{
		color: 'rgba(238, 238, 238, 1)',
		label: 'Grey 200'
	},
	{
		color: 'rgba(224, 224, 224, 1)',
		label: 'Grey 300'
	},
	{
		color: 'rgba(189, 189, 189, 1)',
		label: 'Grey 400'
	},
	{
		color: 'rgba(158, 158, 158, 1)',
		label: 'Grey 500'
	},
	{
		color: 'rgba(117, 117, 117, 1)',
		label: 'Grey 600'
	},
	{
		color: 'rgba(97, 97, 97, 1)',
		label: 'Grey 700'
	},
	{
		color: 'rgba(66, 66, 66, 1)',
		label: 'Grey 800'
	},
	{
		color: 'rgba(33, 33, 33, 1)',
		label: 'Grey 900'
	},
	{
		color: 'rgba(236, 239, 241, 1)',
		label: 'Blue Grey 50'
	},
	{
		color: 'rgba(207, 216, 220, 1)',
		label: 'Blue Grey 100'
	},
	{
		color: 'rgba(176, 190, 197, 1)',
		label: 'Blue Grey 200'
	},
	{
		color: 'rgba(144, 164, 174, 1)',
		label: 'Blue Grey 300'
	},
	{
		color: 'rgba(120, 144, 156, 1)',
		label: 'Blue Grey 400'
	},
	{
		color: 'rgba(96, 125, 139, 1)',
		label: 'Blue Grey 500'
	},
	{
		color: 'rgba(84, 110, 122, 1)',
		label: 'Blue Grey 600'
	},
	{
		color: 'rgba(69, 90, 100, 1)',
		label: 'Blue Grey 700'
	},
	{
		color: 'rgba(55, 71, 79, 1)',
		label: 'Blue Grey 800'
	},
	{
		color: 'rgba(38, 50, 56, 1)',
		label: 'Blue Grey 900'
	}
];
